import { FC } from "react";

import { AccountSetupPollingProgressContent } from "./AccountSetupPollingProgressContent";
import { useSetMissingSubAccountPollingProgress } from "./hooks/useSetMissingSubAccountPollingProgress";
import { useAppSelector } from "../../../../../../store/hooks";

import { pollingSelector } from "../../../../../../store/account-setup/selectors/pollingSelector";

export const AddSubAccountRolePollingProgress: FC = () => {
  const polling = useAppSelector(pollingSelector);

  useSetMissingSubAccountPollingProgress();

  if (!polling) {
    return null;
  }

  return <AccountSetupPollingProgressContent />;
};
